import { render, staticRenderFns } from "./modalEditarCompra.vue?vue&type=template&id=23a1053c&scoped=true"
import script from "./modalEditarCompra.vue?vue&type=script&lang=js"
export * from "./modalEditarCompra.vue?vue&type=script&lang=js"
import style0 from "./modalEditarCompra.vue?vue&type=style&index=0&id=23a1053c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a1053c",
  null
  
)

export default component.exports